module.exports = __webpack_public_path__ + "static/media/aircon.ea6117dd.svg";